export default [{
    id: 1,
    mail_type: 'inbox',
    mail_read: false,
    from_email: 'tommys@mail.com',
    from_name: 'Tommy Sicilia',
    to: ['johndoe@mail.com'],
    img: '1.jpg',
    subject: 'Theme Update',
    message: 'A computer is a machine that can be instructed to carry out sequences of arithmetic or logical operations automatically via computer programming. Modern computers have the ability to follow generalized sets of operations, called programs. These programs enable computers to perform an extremely wide range of tasks. A "complete" computer including the hardware, the operating system (main software), and peripheral equipment required and used for "full" operation can be referred to as a computer system. This term may as well be used for a group of computers that are connected and work together, in particular a computer network or computer cluster.',
    attachments: '',
    labels: 'friend',
    label_color: 'primary',
    time: '07:46',

  },
  {
    id: 2,
    mail_type: 'inbox',
    mail_read: true,
    from_email: 'tressag@mail.com',
    from_name: 'Tressa Gass',
    to: ['johndoe@mail.com'],
    img: '2.jpg',
    subject: 'Company Report',
    message: 'Computers are used as control systems for a wide variety of industrial and consumer devices. This includes simple special purpose devices like microwave ovens and remote controls, factory devices such as industrial robots and computer-aided design, and also general purpose devices like personal computers and mobile devices such as smartphones. The Internet is run on computers and it connects hundreds of millions of other computers and their users.',
    attachments: '1.jpg',
    labels: 'company',
    label_color: 'warning',
    time: '07:55',

  },
  {
    id: 3,
    mail_type: 'spam',
    from_email: 'hettiem@mail.com',
    from_name: 'Hettie Mcerlean',
    to: ['johndoe@mail.com', 'hello@pixinvent.net'],
    img: '3.jpg',
    subject: 'Order Delivered',
    message: 'Early computers were only conceived as calculating devices. Since ancient times, simple manual devices like the abacus aided people in doing calculations. Early in the Industrial Revolution, some mechanical devices were built to automate long tedious tasks, such as guiding patterns for looms. More sophisticated electrical machines did specialized analog calculations in the early 20th century. The first digital electronic calculating machines were developed during World War II. The first semiconductor transistors in the late 1940s were followed by the silicon-based MOSFET (MOS transistor) and monolithic integrated circuit (IC) chip technologies in the late 1950s, leading to the microprocessor and the microcomputer revolution in the 1970s. The speed, power and versatility of computers have been increasing dramatically ever since then, with MOS transistor counts increasing at a rapid pace (as predicted by Moores law) leading to the Digital Revolution during the late 20th to early 21st centuries.',
    attachments: '',
    labels: 'company',
    label_color: 'warning',
    time: '08:35',

  },
  {
    id: 4,
    mail_type: 'spam',
    mail_read: false,
    from_email: 'johndoe@mail.com',
    from_name: 'John Doe',
    to: ['hettiem@mail.com'],
    img: '5.jpg',
    subject: '',
    message: 'Conventionally, a modern computer consists of at least one processing element, typically a central processing unit (CPU) in the form of a metal-oxide-semiconductor (MOS) microprocessor, along with some type of computer memory, typically MOS semiconductor memory. The processing element carries out arithmetic and logical operations, and a sequencing and control unit can change the order of operations in response to stored information. Peripheral devices include input devices (keyboards, mice, joystick, etc.), output devices (monitor screens, printers, etc.), and input/output devices that perform both functions (e.g., the 2000s-era touchscreen). Peripheral devices allow information to be retrieved from an external source and they enable the result of operations to be saved and retrieved.',
    attachments: '',
    labels: 'Work',
    label_color: 'warning',
    time: '10:56',

  },
  {
    id: 5,
    mail_type: 'spam',
    mail_read: false,
    from_email: 'hettiem@mail.com',
    from_name: 'Hettie Mcerlean',
    to: ['johndoe@mail.com'],
    img: '3.jpg',
    subject: '',
    message: 'According to the Oxford English Dictionary, the first known use of the word "computer" was in 1613 in a book called The Yong Mans Gleanings by English writer Richard Braithwait: "I haue [sic] read the truest computer of Times, and the best Arithmetician that euer [sic] breathed, and he reduceth thy dayes into a short number." This usage of the term referred to a human computer, a person who carried out calculations or computations. The word continued with the same meaning until the middle of the 20th century. During the latter part of this period women were often hired as computers because they could be paid less than their male counterparts.[1] By 1943, most human computers were women.',
    attachments: '',
    labels: 'Work',
    label_color: 'danger',
    time: '11:25',

  },
  {
    id: 6,
    mail_type: 'inbox',
    mail_read: false,
    from_email: 'louettae@mail.com',
    from_name: 'Louetta Esses',
    to: ['johndoe@mail.com'],
    img: '4.jpg',
    subject: '',
    message: 'The Online Etymology Dictionary gives the first attested use of "computer" in the 1640s, meaning one who calculates this is an agent noun from compute The Online Etymology Dictionary states that the use of the term to mean calculating machine  (of any type) is from 1897. The Online Etymology Dictionary indicates that the modern use of the term to mean programmable digital electronic computer dates from "1945 under this name [in a] theoretical [sense] from 1937, as Turing machine',
    attachments: '',
    labels: 'business',
    label_color: 'success',
    time: '10:55',
  },
  {
    id: 7,
    mail_type: 'inbox',
    mail_read: false,
    from_email: 'happy@gmail.com',
    from_name: 'Happy Smith',
    to: ['johndoe@mail.com'],
    img: '5.jpg',
    subject: '',
    message: 'Devices have been used to aid computation for thousands of years, mostly using one-to-one correspondence with fingers. The earliest counting device was probably a form of tally stick. Later record keeping aids throughout the Fertile Crescent included calculi (clay spheres, cones, etc.)',
    attachments: '',
    labels: 'promotion',
    label_color: 'primary',
    time: '10:55',
  },
  {
    id: 8,
    mail_type: 'inbox',
    mail_read: false,
    from_email: 'karkitsharma@gmail.com',
    from_name: 'Kartik Sharma',
    to: ['johndoe@mail.com'],
    img: '1.jpg',
    subject: '',
    message: 'The sector, a calculating instrument used for solving problems in proportion, trigonometry, multiplication and division, and for various functions, such as squares and cube roots, was developed in the late 16th century and found application in gunnery, surveying and navigation The planimeter was a manual instrument to calculate the area of a closed figure by tracing over it with a mechanical linkage. ',
    attachments: '',
    labels: 'advertisment',
    label_color: 'danger',
    time: '11:08',
  },
  {
    id: 9,
    mail_type: 'inbox',
    mail_read: false,
    from_email: 'jiyasoni@gmail.com',
    from_name: 'Jiya Soni',
    to: ['johndoe@mail.com'],
    img: '6.jpg',
    subject: '',
    message: 'In the 1770s, Pierre Jaquet-Droz, a Swiss watchmaker, built a mechanical doll (automaton) that could write holding a quill pen. By switching the number and order of its internal wheels different letters, and hence different messages, could be produced. In effect, it could be mechanically utility to navigation in shallow waters. It used a system of pulleys and wires to automatically calculate predicted tide levels for a set period at a particular location. ',
    attachments: '',
    labels: 'client',
    label_color: 'warning',
    time: '10:08',
  },
  {
    id: 10,
    mail_type: 'inbox',
    mail_read: false,
    from_email: 'shraddhakapoor@gmail.com',
    from_name: 'Shraddha Kapoor',
    to: ['johndoe@mail.com'],
    img: '1.jpg',
    subject: '',
    message: 'The machine was about a century ahead of its time. All the parts for his machine had to be made by hand – this was a major problem for a device with thousands of parts. Eventually, the project was dissolved with the decision of the British Government to cease funding. Babbages failure to complete the analytical engine can be chiefly attributed to political and financial difficulties as well as his desire to develop an increasingly sophisticated computer and to move ahead faster than anyone else could follow.Nevertheless, his son, Henry Babbage, completed a simplified version of the analytical engines computing unit(the mill) in 1888. He gave a successful demonstration of its use in computing tables in 1906. ',
    attachments: '',
    labels: 'facebook',
    label_color: 'primary',
    time: '12:15',
  },
  {
    id: 11,
    mail_type: 'spam',
    mail_read: false,
    from_email: 'tressag@mail.com',
    from_name: 'Tressa Gass',
    to: ['johndoe@mail.com'],
    img: '6.jpg',
    subject: 'Company Report',
    message: 'Computers are used as control systems for a wide variety of industrial and consumer devices. This includes simple special purpose devices like microwave ovens and remote controls, factory devices such as industrial robots and computer-aided design, and also general purpose devices like personal computers and mobile devices such as smartphones. The Internet is run on computers and it connects hundreds of millions of other computers and their users.',
    attachments: '1.jpg',
    labels: 'advertisement',
    label_color: 'primary',
    time: '10:15',
  },
  {
    id: 12,
    mail_type: 'sent',
    mail_read: false,
    from_email: 'rutikrohsan@mail.com',
    from_name: 'Rutik Rohsan',
    to: ['johndoe@mail.com'],
    img: '1.jpg',
    subject: 'Computer Technologies',
    message: 'The two principal characteristics of a computer are: It responds to a specific instruction set in a well-defined manner and it can execute a prerecorded list of instructions (a program). There are four main processing steps in a computer: inputting, storage, outputting and processing.',
    attachments: '6.jpg',
    labels: 'technology',
    label_color: 'success',
    time: '09:15',
  },
  {
    id: 13,
    mail_type: 'sent',
    mail_read: false,
    from_email: 'abhijitsingh@mail.com',
    from_name: 'Abhijit Singh',
    to: ['johndoe@mail.com'],
    img: '5.jpg',
    subject: 'Testy Foods',
    message: 'Food is any substance[1] consumed to provide nutritional support for an organism. It is usually of plant or animal origin, and contains essential nutrients, such as carbohydrates, fats, proteins, vitamins, or minerals. The substance is ingested by an organism and assimilated by the organisms cells to provide energy, maintain life, or stimulate growth.',
    attachments: '',
    labels: 'Food',
    label_color: 'warning',
    time: '07:15',
  },
  {
    id: 14,
    mail_type: 'sent',
    mail_read: false,
    from_email: 'akshaykumar@mail.com',
    from_name: 'Akshay Kumar',
    to: ['johndoe@mail.com'],
    img: '1.jpg',
    subject: 'Testy Foods',
    message: 'Most food has its origin in plants. Some food is obtained directly from plants; but even animals that are used as food sources are raised by feeding them food derived from plants. Cereal grain is a staple food that provides more food energy worldwide than any other type of crop.[2] Corn (maize), wheat, and rice – in all of their varieties – account for 87% of all grain production worldwide. Most of the grain that is produced worldwide is fed to livestock.',
    attachments: '',
    labels: 'Food',
    label_color: 'danger',
    time: '17:15',
  },
  {
    id: 15,
    mail_type: 'sent',
    mail_read: false,
    from_email: 'tigershroff@mail.com',
    from_name: 'Tiger Shroff',
    to: ['johndoe@mail.com'],
    img: '2.jpg',
    subject: 'Films',
    message: 'Diet food (or "dietetic food") refers to any food or beverage whose recipe is altered to reduce fat, carbohydrates, abhor/adhore sugar in order to make it part of a weight loss program or diet. Such foods are usually intended to assist in weight loss or a change in body type, although bodybuilding supplements are designed to aid in gaining weight or muscle. The process of making a diet version of a food usually requires finding an acceptable low-food-energy substitute for some high-food-energy ingredient.',
    attachments: '',
    labels: 'Films',
    label_color: 'primary',
    time: '08:25',
  },
  {
    id: 16,
    mail_type: 'draft',
    mail_read: false,
    from_email: 'louettae@mail.com',
    from_name: 'Louetta Esses',
    to: ['johndoe@mail.com'],
    img: '4.jpg',
    subject: '',
    message: 'The Online Etymology Dictionary gives the first attested use of "computer" in the 1640s, meaning one who calculates this is an agent noun from compute The Online Etymology Dictionary states that the use of the term to mean calculating machine  (of any type) is from 1897. The Online Etymology Dictionary indicates that the modern use of the term to mean programmable digital electronic computer dates from "1945 under this name [in a] theoretical [sense] from 1937, as Turing machine',
    attachments: '',
    labels: 'business',
    label_color: 'success',
    time: '10:55',
  }, {
    id: 17,
    mail_type: 'draft',
    mail_read: false,
    from_email: 'happy@gmail.com',
    from_name: 'Happy Smith',
    to: ['johndoe@mail.com'],
    img: '5.jpg',
    subject: '',
    message: 'Devices have been used to aid computation for thousands of years, mostly using one-to-one correspondence with fingers. The earliest counting device was probably a form of tally stick. Later record keeping aids throughout the Fertile Crescent included calculi (clay spheres, cones, etc.)',
    attachments: '',
    labels: 'promotion',
    label_color: 'primary',
    time: '10:55',
  }, {
    id: 18,
    mail_type: 'draft',
    mail_read: false,
    from_email: 'karkitsharma@gmail.com',
    from_name: 'Kartik Sharma',
    to: ['johndoe@mail.com'],
    img: '1.jpg',
    subject: '',
    message: 'The sector, a calculating instrument used for solving problems in proportion, trigonometry, multiplication and division, and for various functions, such as squares and cube roots, was developed in the late 16th century and found application in gunnery, surveying and navigation The planimeter was a manual instrument to calculate the area of a closed figure by tracing over it with a mechanical linkage. ',
    attachments: '',
    labels: 'advertisment',
    label_color: 'danger',
    time: '11:08',
  }, {
    id: 19,
    mail_type: 'draft',
    mail_read: false,
    from_email: 'jiyasoni@gmail.com',
    from_name: 'Jiya Soni',
    to: ['johndoe@mail.com'],
    img: '6.jpg',
    subject: '',
    message: 'In the 1770s, Pierre Jaquet-Droz, a Swiss watchmaker, built a mechanical doll (automaton) that could write holding a quill pen. By switching the number and order of its internal wheels different letters, and hence different messages, could be produced. In effect, it could be mechanically utility to navigation in shallow waters. It used a system of pulleys and wires to automatically calculate predicted tide levels for a set period at a particular location. ',
    attachments: '',
    labels: 'client',
    label_color: 'warning',
    time: '10:08',
  },
]